export default function(enable) {

    this._options.fade = enable

    return this;
};
